import React, { Children } from "react";

type IDeepIterationsCallback = (data: React.ReactElement) => void;

export function deepMap(children: React.ReactElement, cb?: IDeepIterationsCallback): Array<React.ReactElement> | any {
    return Children.map(children, (child) => {
        
        if(child && cb) {
            return cb(child)
        }

        if(child && child.props && Array.isArray(child.props.children)) {
            return React.cloneElement(child, {
                ...child.props,
                children: deepMap(child.props.children, cb)
            })
        }

        return child;

    })
}

export function deepForeach(children: React.ReactElement, cb: IDeepIterationsCallback): void {
    return Children.forEach(children, (child) => {

        if(child) {
            cb(child);
        }

        if(child && child.props && Array.isArray(child.props.children)) {
            return React.cloneElement(child, {
                ...child.props,
                children: deepForeach(child.props.children, cb)
            })
        }
    })
}